import "../../css/GlobalStyles.css";
import { ReactNode, memo, useEffect, useState } from "react";
import { Colors } from "../../utils/colors";
import { useSelector } from "react-redux";
import { getAccountState, LoginState } from "../../redux/slices/accountSlice";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import TopHeader from "../TopHeader";
import Footer from "../Footer";
import { ThemeType } from "@markit/common.types";

// Same fallback image the server-side (functions/index.js) uses for OG tags.
const DEFAULT_OG_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/markit-d5e9b.appspot.com/o/metaImagePreviews%2FTextingForCreatorsPreview.jpg?alt=media&token=d7ae1aab-c4e9-4a98-bb5f-55461ed29443";

type LandingPagesWrapperProps = {
  helmetData: {
    title: string;
    metaContent: string;
    link: string;
  };
  children: ReactNode;
  preventLogoClick?: boolean;
  noRedirect?: boolean;
};

const LandingPagesWrapper = (props: LandingPagesWrapperProps) => {
  const { helmetData, children, preventLogoClick, noRedirect } = props;

  const { account } = useSelector(getAccountState);
  const { accountData, loggedIn } = account;
  const navigate = useNavigate();

  // Add state for mobile nav
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  // Navigation effect
  useEffect(() => {
    if (
      loggedIn === LoginState.LOGGED_IN &&
      accountData.inCreatorMode &&
      !noRedirect
    ) {
      navigate("/home");
    }
  }, [loggedIn, accountData.inCreatorMode, navigate, noRedirect]);

  return (
    <div
      className={isMobileNavOpen ? "PreventAllScrolling" : ""}
      style={{
        backgroundColor: Colors.BLACK,
        overflowX: "hidden",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>{helmetData.title}</title>
        <meta name="description" content={helmetData.metaContent} />
        <link rel="canonical" href={helmetData.link} />
        <meta property="og:title" content={helmetData.title} />
        <meta property="og:description" content={helmetData.metaContent} />
        <meta property="og:url" content={helmetData.link} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={helmetData.title} />
        <meta name="twitter:description" content={helmetData.metaContent} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <TopHeader
        whiteLogo
        nonCreatorPage
        preventLogoClick={preventLogoClick}
        onMobileNavOpenChange={setIsMobileNavOpen}
        eventTheme={ThemeType.Dark}
      />
      {children}
      <Footer eventTheme={ThemeType.Dark} />
    </div>
  );
};

export default memo(LandingPagesWrapper);
